var hasSearchQuery = function() {
  const queryPattern = '?query=';
  return location.search.startsWith(queryPattern) && location.search !== queryPattern;
};

export default hasSearchQuery;
